import useCustomerNavigation from '@/Hooks/Company/Navigation/useCustomerNavigation'
import useProductNavigation from '@/Hooks/Company/Navigation/useProductNavigation'
import useAvailabilityNavigation from '@/Hooks/Company/Navigation/useAvailabilityNavigation'
import useSettingsNavigation from '@/Hooks/Company/Navigation/useSettingsNavigation'
import useAppStoreNavigation from '@/Hooks/Company/Navigation/useAppStoreNavigation'
import useHoustonNavigation from '@/Hooks/Company/Navigation/useHoustonNavigation'
import useCustomerPortalNavigation from '@/Hooks/Company/Navigation/useCustomerPortalNavigation'

import { useCurrentRoute } from '@/Hooks/Shared/useCurrentRoute'

export function useSecondaryNavigation() {
  const { currentUrlMatchesRouteNames } = useCurrentRoute()

  const currentUrlMatchesOverviewRouteNameOfNavigation = (navigation) => {
    return currentUrlMatchesRouteNames(navigation.overviewRouteName)
  }

  const currentUrlMatchesCurrentRouteNamesOfNavigation = (navigation) => {
    return navigation.sections
      .flatMap((navigationSection) => navigationSection.children)
      .flatMap((navigationItem) => navigationItem.routeNamesToCheckIfCurrent)
      .some((routeName) => currentUrlMatchesRouteNames(routeName))
  }

  const secondaryNavigationForCurrentUrl = () => {
    return [
      useCustomerNavigation(),
      useProductNavigation(),
      useAvailabilityNavigation(),
      useAppStoreNavigation(),
      useSettingsNavigation(),
      useHoustonNavigation(),
      useCustomerPortalNavigation()
    ].find(
      (navigation) =>
        currentUrlMatchesOverviewRouteNameOfNavigation(navigation) ||
        currentUrlMatchesCurrentRouteNamesOfNavigation(navigation)
    )
  }

  return {
    secondaryNavigationForCurrentUrl
  }
}
